export default v2Color => {
  return {
    id: v2Color.guid,
    label: v2Color.name,
    swatchColor: v2Color.swatchColor,
    sortOrder: v2Color.sortOrder
  };
};
